import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment as env } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ProfileService {
  private apiUrl = `${env.apiUrl}/user/v1/user`;
  

  constructor(private http: HttpClient) { }

 
  // getProfile(id: number) {
  //   return this.http.get<any>(`${this.apiUrl}/${id}`);
  // }
  getProfileFromLocal(){
    const userinfo=localStorage.getItem('userInfo');
    return(userinfo);
  }

  updateProfile(data: any,id:number) {
    return this.http.put(`${this.apiUrl}/${id}`, data);

  }

}
